import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import logo from '../../traderhub24-logo.svg'
import { useAuth } from '../contexts/AuthContext'
import '../app-test.css'

export default function AdminLogin() {
  const { t } = useTranslation('auth')
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    setLoading(true)
    const { error: signInError } = await signIn(email.trim(), password)
    setLoading(false)
    if (signInError) {
      setError(signInError.message || t('login.errorOccurred'))
    }
  }

  return (
    <div className="app-test at-admin-login">
      <div className="at-backdrop-orb at-orb-one" aria-hidden />
      <div className="at-backdrop-orb at-orb-two" aria-hidden />
      <form className="at-admin-login-card" onSubmit={handleSubmit}>
        <div className="at-brand at-admin-login-brand">
          <img src={logo} alt="TraderHub24" />
        </div>
        <p className="at-admin-login-kicker">Administration</p>
        <h1>Sign in to admin</h1>
        <p className="at-admin-login-sub">Use your administrator account. This session is separate from the main app.</p>
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && <p className="at-admin-login-error" role="alert">{error}</p>}
        <button type="submit" className="at-export at-admin-login-submit" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
